import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ContactsDirectoryPage } from '@/pages/member-portal/contacts/ContactsDirectoryPage';

const searchSchema = z.object({
	preview: z.boolean().optional(),
	type: z.enum(['SUPPLIER']).optional(),
	supplierId: z
		.string()
		.regex(/^[a-f0-9]{24}$/)
		.optional(),
});

function MemberPortalContactsRoute() {
	return <ContactsDirectoryPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/contacts')({
	validateSearch: searchSchema,
	component: MemberPortalContactsRoute,
});
